import { Component, Input, OnInit } from '@angular/core';
import { Client } from '../../../../../projects/shared-lib/src/lib/models/client';
import { Router } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ClientService } from '../../../client/client.service';
import { MatIcon } from '@angular/material/icon';
import { PhonePipe } from '../../../../../projects/shared-lib/src/lib/pipe/phone.pipe';

@Component({
    selector: 'tw-client-view',
    templateUrl: './client-view.component.html',
    styleUrls: ['./client-view.component.css'],
    imports: [MatIcon, TranslatePipe, PhonePipe]
})
export class ClientViewComponent implements OnInit {

    @Input() client:any| Client = <any|Client>{};
    hideEditButton = false;
    @Input() showOnlyClientView = false;
    @Input() showAddress = true;

    constructor(private router: Router,
                public translate: TranslateService, private clientService: ClientService) {

        this.hideEditButton = router.url.search('checkout-confirmation') !== -1
            || router.url.search('reservationToken') !== -1
            || router.url.search('checkout-deferred') !== -1
            || router.url.search('checkout-colts') !== -1;
        //console.log(this.hideEditButton);
    }

    ngOnInit() {
    }

    goEditClient() {
        if (this.clientService.isLoggedInFromSession()) {
            this.router.navigate([this.translate.currentLang + '/client/auth/profile'], { queryParamsHandling: 'merge' });
        } else {
            this.router.navigate([this.translate.currentLang + '/client/profile-guest'], { queryParamsHandling: 'merge' });
        }
    }

}
